const templateColumnConfigs = [
  {
    header: 'Hosting Entity Name*',
    key: 'hostingEntityName',
    width: 40,
    required: true,
    example: 'Main Data Center',
    type: 'Text',
  },
  {
    header: 'Hosting Asset / Server*',
    key: 'hostingAssetServer',
    width: 40,
    required: true,
    example: 'Server123',
    type: 'Text',
  },
  {
    header: 'Type*',
    key: 'type',
    width: 30,
    required: true,
    options: ['Physical', 'Virtual', 'Network', 'Storage'],
    example: 'Physical',
    type: 'Dropdown',
  },
  {
    header: 'IT Owner (Name & Email)*',
    key: 'itOwner',
    width: 50,
    required: true,
    example: 'John Doe (john.doe@example.com)',
    type: 'Text',
  },
  {
    header: 'Business Owner (Name & Email)*',
    key: 'businessOwner',
    width: 50,
    required: true,
    example: 'Jane Smith (jane.smith@example.com)',
    type: 'Text',
  },
  {
    header: 'Address (Optional)',
    key: 'address',
    width: 50,
    required: false,
    example: '1234 Business Lane, City, Country',
    type: 'Text',
  },
  {
    header: 'Rebuild Time (Months)*',
    key: 'rebuildTimeMonths',
    width: 30,
    required: true,
    example: 6,
    type: 'Number (months)',
  },
  {
    header: 'DR in Place*',
    key: 'drInPlace',
    width: 20,
    required: true,
    example: true,
    type: 'Boolean',
  },
  {
    header: 'DR Tier (Optional)',
    key: 'tier.name',
    width: 50,
    required: false,
    options: [
      'Tier 0: high availability / 0 downtime',
      'Tier 1: 4 hour - RPO 1 hour',
      'Tier 2: 24 hour - RPO 1 hour',
      'Tier 3: Best effort - RPO 48 hours',
      '99: no DR',
    ],
    example: 'Tier 1: 4 hour - RPO 1 hour',
    type: 'Dropdown',
  },
];

export { templateColumnConfigs };
